module.exports = "../images/boats@2x.jpg?v=2a8b55b";